<template>
  <v-container>
    <Checkout v-if="checkoutItem" :plan="checkoutItem" @cancel="onCancel" />
    <v-row v-else align="center" justify="center">
      <v-col cols="12">
        <v-card-title class="ma-auto pa-0">
          <v-spacer />
          <h3 v-if="yearly" class="text--disabled">Monthly</h3>
          <h3 v-else>Monthly</h3>
          <v-switch v-model="yearly" class="mx-5"></v-switch>
          <h3 v-if="!yearly " class="text--disabled">Yearly</h3>
          <h3 v-else>Yearly</h3>
          <v-spacer></v-spacer>
        </v-card-title>
      </v-col>
      <v-col v-for="plan in items" :key="plan.id" cols="12" sm="12" md="4" lg="4">
        <Plans :item="plan" @checkout="onCheckout" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { PLAN } from "@/store/actions.type";
import { mapGetters } from "vuex";
import Plans from "@/components/products/Card";
import Checkout from "@/components/payments/Checkout";
import planA from "@/assets/bluetheme/pricing/individual.png";
import planB from "@/assets/bluetheme/pricing/group.png";
import planC from "@/assets/bluetheme/pricing/team.png";
export default {
  name: "Prices",
  components: { Plans, Checkout },
  data() {
    return {
      checkoutItem: null,
      yearly: true,
      items: null,
      settings: [
        {
          img: planA,
          color: "primary lighten-4"
        },
        {
          img: planB,
          color: "primary lighten-3"
        },
        {
          img: planC,
          color: "primary"
        }
      ]
    };
  },

  computed: {
    ...mapGetters(["currentUser", "plans"])
  },
  watch: {
    plans() {
      this.getItems();
    },
    yearly() {
      this.getItems();
    }
  },

  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      if (!this.plans) {
        this.$store.dispatch(PLAN.FETCH);
      } else if (this.plans) {
        this.getItems();
      }
    },
    getItems() {
      this.items = this.plans
        .filter(plan => {
          if (this.yearly) {
            return plan.month == 12 || plan.month < 0;
          } else {
            return plan.month == 1 || plan.month < 0;
          }
        })
        .sort((a, b) => {
          return a.price - b.price;
        });
      this.changeImg();
    },
    changeImg() {
      for (let i in this.items) {
        this.items[i].img = this.settings[i].img;
        this.items[i].color = this.settings[i].color;
      }
    },
    onCheckout(val) {
      this.checkoutItem = val;
    },
    onCancel() {
      this.checkoutItem = null;
    }
  }
};
</script>

<style>
</style>